import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input, ValidaUid } from "../components";
import { db } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import moment from "moment";

const Inicio = () => {
  const hoje = moment().format("YYYY-MM-DD");

  let min = "2026-08-01";
  if (hoje > min) min = hoje;

  let max = "2027-08-31";

  const [dados, setDados] = useState({});
  const [inicio, setInicio] = useState(min);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const setData = async () => {
    await setDoc(
      doc(db, "ebserh2026", dados.uid),
      { dataInicio: inicio },
      { merge: true }
    );
  };

  const handleChange = (e) => {
    setInicio(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    setData().then(() => navigate("../aceite"));
  };

  useEffect(() => {
    const buscaDados = async () => {
      const uid = await ValidaUid();

      if (uid) {
        const qry = await getDoc(doc(db, "ebserh2026", uid));

        const data = qry.data();

        if (data?.anoAtual === "2026" && data?.status) {
          navigate("../home");
        } else {
          setDados(data);
          setLoading(false);
        }
      } else {
        navigate("/login");
      }
    };

    buscaDados();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      {loading && <Loading />}

      <Frame
        body={
          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="m-3"
            noValidate
          >
            <Row>
              <Col sm={12} className="my-2 text-start">
                <Input
                  id="inicio"
                  label="Selecione a data de início do fretamento"
                  type="date"
                  min={min}
                  max={max}
                  value={inicio}
                  onChange={handleChange}
                  autoFocus
                />
              </Col>
            </Row>
            {max > hoje && (
              <Row className="my-2">
                <Col sm={12} className=" d-grid">
                  <button type="submit" className="btn btn-primary">
                    Avançar
                  </button>
                </Col>
              </Row>
            )}
          </form>
        }
        title="Data de Início"
      />
    </>
  );
};

export default Inicio;
